<ngb-datepicker
  class="date-picker"
  navigation="none"
  (dateSelect)="handleDateSelection($event)"
  [displayMonths]="1"
  [dayTemplate]="t"
  [minDate]="minNgbDate"
  [maxDate]="maxNgbDate"
  [markDisabled]="markDisabled ?? undefined"
  [contentTemplate]="c"
  [footerTemplate]="f"
  [startDate]="fromDate!"
  outsideDays="hidden"
  tabindex="-1" />

<ng-template #t let-date let-disabled="disabled">
  <span
    class="custom-day"
    [class.range]="isRange(date)"
    [class.faded]="isHovered(date) || isInside(date)"
    [class.disabled]="disabled"
    (mouseenter)="hoveredDate = date"
    (mouseleave)="hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>

<ng-template #f>
  <div class="action-buttons">
    <button type="button" i18n (click)="clear()">Reset</button>
    <button type="button" i18n (click)="emitDateSelection()">Confirm</button>
  </div>
</ng-template>

<ng-template #c let-dp>
  <div class="month-picker">
    <div class="picker-dropdowns">
      <div class="picker-dropdown">
        <button
          type="button"
          class="picker-dropdown-toggle"
          aria-label="Select month"
          i18n-aria-label
          [attr.aria-expanded]="openedDropdown === 'month'"
          (click)="toggleDropdown('month', $event)"
          (keydown.escape)="closeDropdown()">
          {{ dp.state.focusedDate.month | getMonthShortName }}
        </button>
        <div class="picker-dropdown-panel" *ngIf="openedDropdown === 'month'">
          <button
            type="button"
            class="picker-dropdown-option"
            *ngFor="let month of monthOptions; trackBy: trackByValue"
            [class.selected]="month === dp.state.focusedDate.month"
            [disabled]="isMonthDisabled(dp, month)"
            (click)="selectMonth(dp, month)">
            {{ month | getMonthShortName }}
          </button>
        </div>
      </div>
      <div class="picker-dropdown">
        <button
          type="button"
          class="picker-dropdown-toggle"
          aria-label="Select year"
          i18n-aria-label
          [attr.aria-expanded]="openedDropdown === 'year'"
          (click)="toggleDropdown('year', $event)"
          (keydown.escape)="closeDropdown()">
          {{ dp.state.focusedDate.year }}
        </button>
        <div class="picker-dropdown-panel" *ngIf="openedDropdown === 'year'">
          <button
            type="button"
            class="picker-dropdown-option"
            *ngFor="let year of yearOptions; trackBy: trackByValue"
            [class.selected]="year === dp.state.focusedDate.year"
            (click)="selectYear(dp, year)">
            {{ year }}
          </button>
        </div>
      </div>
    </div>
    <div class="navigation">
      <button
        type="button"
        class="navigation-button"
        aria-label="Previous month"
        i18n-aria-label
        (click)="navigate(dp, -1)">
        <img [src]="'assets/icons/inputs/datepicker/ChevronLeft.svg'" alt="" />
      </button>
      <span class="month">{{ dp.state.focusedDate.month | getMonthName }}</span>
      <button type="button" class="navigation-button" aria-label="Next month" i18n-aria-label (click)="navigate(dp, 1)">
        <img [src]="'assets/icons/inputs/datepicker/ChevronRight.svg'" alt="" />
      </button>
    </div>
    <div *ngFor="let month of dp.state.months; trackBy: trackByIndex">
      <ngb-datepicker-month [month]="month" />
    </div>
  </div>
</ng-template>
